import styled from '@mui/material/styles/styled';
import React from 'react';
import PropTypes from 'prop-types';

const StyledButton = styled('button', {
  shouldForwardProp: (prop) =>
    !['border', 'bgColor', 'disableWrap'].includes(prop),
})(
  ({
    theme,
    border,
    disabled,
    fontSize,
    fontWeight,
    bgColor,
    disableWrap,
  }) => ({
    display: 'flex',
    alignItems: 'center',
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    textAlign: 'left',
    fontSize: fontSize,
    fontWeight: fontWeight,
    border: border,
    userSelect: 'none',
    padding: '1px 8px',
    borderRadius: '4px',
    backgroundColor: bgColor || theme.palette.background.white,
    '&:hover': {
      ...(!disabled && {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.innerGray,
      }),
    },
    [theme.breakpoints.down('sm')]: disableWrap
      ? {}
      : {
          flexDirection: 'column',
          alignItems: 'center',
        },
  })
);

function StyledLinkButton(props) {
  const { children, border, ...rest } = props;
  return (
    <StyledButton border={border} {...rest}>
      {children}
    </StyledButton>
  );
}

StyledLinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  border: PropTypes.string,
  disabled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bgColor: PropTypes.string,
  disableWrap: PropTypes.bool,
};

StyledLinkButton.defaultProps = {
  border: 'none',
  disabled: false,
  fontSize: '0.875rem',
  fontWeight: 600,
  bgColor: null,
  disableWrap: false,
};

export default StyledLinkButton;
